import { render, staticRenderFns } from "./BrickCircleEndpoints.vue?vue&type=template&id=877b6d6a&"
import script from "./BrickCircleEndpoints.vue?vue&type=script&lang=js&"
export * from "./BrickCircleEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('877b6d6a')) {
      api.createRecord('877b6d6a', component.options)
    } else {
      api.reload('877b6d6a', component.options)
    }
    module.hot.accept("./BrickCircleEndpoints.vue?vue&type=template&id=877b6d6a&", function () {
      api.rerender('877b6d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickCircleEndpoints.vue"
export default component.exports